var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            "show-close": true,
            "close-on-click-modal": true,
            "close-on-press-escape": false,
            "append-to-body": true,
            "custom-class": "how-it-works-modal",
          },
          on: { "update:visible": _vm.updateVisible, close: _vm.handleClose },
        },
        [
          _c("div", { staticClass: "how-it-works" }, [
            _c("h2", [_vm._v("How it works")]),
            _vm._v(" "),
            _c("iframe", {
              attrs: {
                id: "vimeoPlayer",
                width: "558",
                height: "328",
                src: "https://player.vimeo.com/video/1072560945?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
                frameborder: "0",
                allow:
                  "autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media",
                title: "Vixio Workspace",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tooltip-assist" },
              [
                _vm.workspaceAccess
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "button button__primary start-here button-link",
                        attrs: {
                          href: _vm.createChecklistsUrl,
                          target: "_blank",
                        },
                      },
                      [_vm._v("Get started")]
                    )
                  : _c(
                      "el-button",
                      {
                        staticClass:
                          "button button__primary start-here button-link",
                        on: { click: _vm.openDemoLink },
                      },
                      [_vm._v("Book a demo with the team")]
                    ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }